import React from 'react'
import { Helmet } from 'react-helmet'
import Term from '../images/Terms.png'
function Terms() {
    return (
        <div>
            <Helmet>
                <title>Parcelx - Terms & Conditions</title>
            </Helmet>
            <section className='section01 pb-0 trmsss'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <div className="row align-items-center">
                        <div className="col-md-6 order-md-2 text-md-end">
                            <img src={Term} height="350" alt="" />
                        </div>
                        <div className="col-lg-6">
                            <h1 className="display-3">Terms & Conditions</h1>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
            <section className='section01 pb-0 trmsss'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <h3>Data Protection & Security Policy</h3>
                        <p><span>ParcelX – Data Protection & Security Policy</span></p>
                        <p className="text-muted">This document outlines how ParcelX protects data accessed via the <span>Amazon Selling Partner API (SP-API)</span> and customer data.</p>
                        <h3>Data Handling Principles</h3>
                        <ul>
                        <li><span>Data Minimization: </span>Only essential order and customer details required for shipping are accessed.</li>
                        <li><span>Purpose Limitation:</span> Amazon data is used <span>only</span> for order fulfillment.</li>
                        <li><span>Restricted Access:</span> Only authorized employees with shipping-related duties may access Amazon data.</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className='section02 pt-0 trmsss'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <h3>Data Retention & Disposal</h3>
                        <ul>
                        <li><span>Amazon SP-API Data:</span> Retained for <span>no longer than 30 days</span> after order completion, unless required for disputes or law.</li>
                        <li><span>Backup Retention:</span> Encrypted backups stored for <span>90 days</span> maximum.</li>
                        <li><span>Secure Deletion:</span> Expired data is permanently erased using <span>NIST SP 800-88 standards.</span></li>
                        </ul>
                        <h3>Security Measures</h3>
                        <p><span>Encryption Standards</span></p>
                        <ul>
                        <li>Data in transit: TLS 1.2+</li>
                        <li>Data at rest: AES-256</li>
                        <li>Passwords: Salted & hashed (bcrypt/SHA-256)</li>
                        </ul>
                        <p><span>Access Management</span></p>
                        <ul>
                        <li>MFA required for all developer and admin accounts</li>
                        <li>Role-based access with “least privilege” enforcement</li>
                        <li>Employee offboarding triggers immediate credential revocation</li>
                        </ul>
                        <p><span>System Monitoring & Logging</span></p>
                        <ul>
                        <li>Centralized logging of all Amazon API calls</li>
                        <li>Logs retained for 90 days for investigation</li>
                        <li>Automated alerts on suspicious access</li>
                        </ul>
                        <p><span>Infrastructure Security</span></p>
                        <ul>
                        <li>Hosted on <span>ISO 27001, SOC 2 compliant cloud providers</span></li>
                        <li>Regular patching & vulnerability scanning</li>
                        <li>Web Application Firewall (WAF) for API protection</li>
                        </ul>
                        <h3>Incident Response Plan</h3>
                        <ul>
                        <li><span>Detection:</span> Continuous monitoring & intrusion detection</li>
                        <li><span>Containment:</span> Isolate affected servers immediately</li>
                        <li><span>Notification:</span> Amazon & regulators notified within <span>72 hours</span> if breach involves SP-API data</li>
                        <li><span>Recovery:</span> Data restored from secure backups</li>
                        <li><span>Post-Mortem:</span> Root cause analysis & policy improvements documented</li>
                        </ul>
                        <h3>Employee Training & Governance</h3>
                        <ul>
                        <li>All employees undergo <span>annual data protection training</span></li>
                        <li>Signed <span>Confidentiality & NDA agreements</span> are mandatory</li>
                        <li>Regular phishing & security awareness simulations</li>
                        </ul>
                        <h3>Legal & Regulatory Compliance</h3>
                        <ul>
                        <li><span>DPDPA 2023 (India)</span> – Consent, purpose limitation, user rights</li>
                        <li><span>IT Act 2000 & IT Rules 2011</span> – Reasonable security practices</li>
                        <li><span>Amazon SP-API Policy</span> – Data must not be shared, resold, or misused</li>
                        <li><span>GDPR (where applicable)</span> – Data subject rights, secure processing</li>
                        </ul>
                        <h3>Contact for Security Concerns</h3>
                        <p><span>Data Protection Officer (DPO)</span></p>
                        <p>Email: <a href="https://mail.google.com/mail/?view=cm&fs=1&to=support@parcelx.in" target="_blank" rel="noopener noreferrer">support@parcelx.in</a></p>
                        <p>Address: Unit No. 8.4, 8th Floor, Eco Towers, Plot A-14, Sector-125, Noida – 201301, UP, India</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Terms
